export class User {
    email: string;
    fullName: string;
    idAdmin: string;
    isAdmin: boolean;
    accessToken: string;
    features: string[];
    refreshToken: string;
    remember: boolean;
    role: string;
    active: string;

    constructor(params: any) {
        this.isAdmin = params.isAdmin;
        this.accessToken = params.accessToken;
        this.idAdmin = params.idAdmin;
        this.fullName = params.fullName;
        this.refreshToken = params.refreshToken;
        this.role = params.role;
        this.features = params.features;
        this.remember = params.remember;
        this.email = params.email;
        this.active = params.active;
    }
}
